import React from "react";
import { Text, Flex } from "@jsq/ds/core";
import { DetailedBacsPaymentPrefObjectType } from "../../../common/types";
import FormattedAddress from "../FormattedAddress";
import PaymentDetailsModalField from "../PaymentDetailsModalField";
import { BacsVisibleFields } from "../types";
import { getAddress } from "../utils";
import { isBacsFieldVisible } from "../utils/fieldVisibility";

const formatSortCode = (sortCode: string): string =>
  `${sortCode.slice(0, 2)}-${sortCode.slice(2, 4)}-${sortCode.slice(4, 6)}`;

export type BacsPaymentPrefDisplayProps = {
  bacsPaymentPrefFull: DetailedBacsPaymentPrefObjectType;
  visibleFields?: BacsVisibleFields;
};

export const BacsPaymentPrefDisplay: React.FC<BacsPaymentPrefDisplayProps> = ({
  bacsPaymentPrefFull,
  visibleFields,
}: BacsPaymentPrefDisplayProps) => {
  const accountHolderAddress =
    bacsPaymentPrefFull.accountHolderAddress &&
    getAddress(bacsPaymentPrefFull.accountHolderAddress);

  const gap = 8; // gap between rows and columns

  return (
    <Flex gap={gap} flexDirection="column" data-testid="BacsPaymentPrefDisplayFlex">
      <PaymentDetailsModalField
        label="Account holder name"
        value={bacsPaymentPrefFull.accountName}
        gap={gap}
        visible={isBacsFieldVisible("accountName", visibleFields)}
      />
      <PaymentDetailsModalField
        label="Sort code"
        value={
          bacsPaymentPrefFull.bank?.sortCode &&
          formatSortCode(bacsPaymentPrefFull.bank.sortCode)
        }
        gap={gap}
        visible={isBacsFieldVisible("bank", visibleFields)}
      />
      <PaymentDetailsModalField
        label="Account number"
        value={bacsPaymentPrefFull.accountNumber}
        gap={gap}
        visible={isBacsFieldVisible("accountNumber", visibleFields)}
      />
      <PaymentDetailsModalField
        label="Bank name"
        value={bacsPaymentPrefFull.bank?.name}
        gap={gap}
        visible={isBacsFieldVisible("bank", visibleFields)}
      />
      {bacsPaymentPrefFull.additionalInstructions && (
        <PaymentDetailsModalField
          label="Additional instructions"
          value={bacsPaymentPrefFull.additionalInstructions}
          gap={gap}
          visible={isBacsFieldVisible("additionalInstructions", visibleFields)}
        />
      )}
      {isBacsFieldVisible("accountHolderAddress", visibleFields) && (
        <Flex gap={gap}>
          <Flex flexBasis="60%">
            <Text variant="secondary-md">Account holder address</Text>
          </Flex>
          <Flex flexBasis="100%" flexDirection="column">
            {accountHolderAddress && (
              <FormattedAddress address={accountHolderAddress} variant="regular-md" />
            )}
          </Flex>
        </Flex>
      )}
    </Flex>
  );
};
